import { render, staticRenderFns } from "./afterInvoice.vue?vue&type=template&id=d52e5c18&scoped=true"
import script from "./afterInvoice.vue?vue&type=script&lang=js"
export * from "./afterInvoice.vue?vue&type=script&lang=js"
import style0 from "./afterInvoice.vue?vue&type=style&index=0&id=d52e5c18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52e5c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d52e5c18')) {
      api.createRecord('d52e5c18', component.options)
    } else {
      api.reload('d52e5c18', component.options)
    }
    module.hot.accept("./afterInvoice.vue?vue&type=template&id=d52e5c18&scoped=true", function () {
      api.rerender('d52e5c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/afterInvoice.vue"
export default component.exports